import { COLORS } from '../../../utils/colors';

export const useCustomModalStyles = () => {
  return {
    confirmButton: { fontSize: '13px', textTransform: 'none' },
    cancelButton: {
      color: COLORS.PRIMARY,
      fontWeight: 500,
      textTransform: 'none',
    },
  };
};
